// Relationship graph helpers shared by the Builder (drop-time validation) and the Model view.

// Undirected adjacency over ACTIVE join contracts.
export function relationshipGraph(contracts) {
  const adj = new Map();
  (contracts || []).forEach((c) => {
    if (c.active === false || (c.broken_keys || []).length || !c.left_dataset_id || !c.right_dataset_id) return;
    if (!adj.has(c.left_dataset_id)) adj.set(c.left_dataset_id, new Set());
    if (!adj.has(c.right_dataset_id)) adj.set(c.right_dataset_id, new Set());
    adj.get(c.left_dataset_id).add(c.right_dataset_id);
    adj.get(c.right_dataset_id).add(c.left_dataset_id);
  });
  return adj;
}

// True when a chain of relationships (bridges allowed) links dataset a to dataset b.
export function hasRelationshipPath(a, b, contracts) {
  if (!a || !b) return false;
  if (a === b) return true;
  const adj = relationshipGraph(contracts);
  const seen = new Set([a]);
  const queue = [a];
  while (queue.length) {
    const cur = queue.shift();
    for (const n of adj.get(cur) || []) {
      if (n === b) return true;
      if (!seen.has(n)) { seen.add(n); queue.push(n); }
    }
  }
  return false;
}

// Datasets from `candidates` that are NOT reachable from `from`.
export function unreachableDatasets(from, candidates, contracts) {
  return [...new Set(candidates || [])].filter((id) => id && id !== from && !hasRelationshipPath(from, id, contracts));
}
